module.exports = __webpack_public_path__ + "static/media/1033166.c4c687a3.jpg";